import { createSlice } from '@reduxjs/toolkit';
import { findQuestionGroupAPI, getQuestionGroupByIdAPI } from '../../../service/quiz/quiz.questionGroup.service';

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  qGroups: [],
  qGroup: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: 'asc',
        property: 'createdAt',
      },
    ],
  },
};

const slice = createSlice({
  name: 'qGroup',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setQuestionGroups(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.qGroups = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setQuestionGroup(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.qGroup = response.data;
    },
    setQuestionGroupSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;
// Actions
export const { setQuestionGroupSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getQuestionGroups() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { qGroup } = getState();

    const resp = await findQuestionGroupAPI({ ...qGroup.search, value: `%${qGroup.search.value}%` });

    if (resp.code === '200') dispatch(slice.actions.setQuestionGroups(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}

export function getQuestionGroup(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    const resp = await getQuestionGroupByIdAPI(id);
    if (resp.code === '200') dispatch(slice.actions.setQuestionGroup(resp));
    else dispatch(slice.actions.hasError(resp));
  };
}
